// @flow strict

import React from 'react';

import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Grid, Box } from '@material-ui/core';

import { Author } from '~components/author/author';
import { createLinkPath } from '~utils/helpers/create-link-path';

import type { PostNode } from '~types/post';

import * as styles from './front-post.module.less';

/**
 * Type of component properties.
 */
type FrontPostProps = {
  post: PostNode,
  className?: string,
};

/**
 * Component to show post preview on top of the page.
 *
 * @param {FrontPostProps} props - Component properties
 *
 * @returns {Node}
 */
export const FrontPost = ({ post, className }: FrontPostProps) => {
  const { frontmatter, excerpt, fields, timeToRead } = post;

  const { title, category, permalink, image, date } = frontmatter;

  // show error to detect posts with missing images
  if (image == null) {
    console.error('blog post does not have an image', title);
  }

  const imagePath = image == null ? '' : image.childImageSharp.gatsbyImageData;

  return (
    <article className={`${styles.post} ${className || ''}`}>
      {/* Mobile only */}
      <Box component="header" display={{ md: 'none' }}>
        <Link to={permalink}>
          <p className={styles.category}>{category}</p>

          <h2 className={styles.headlinePost}>{title}</h2>
        </Link>
      </Box>

      <Grid container spacing={4}>
        <Grid component="figure" item xs={12} md={8}>
          <Link to={permalink}>
            <GatsbyImage image={imagePath} alt="Blog post thumbnail" />
          </Link>
        </Grid>

        <Grid item xs={12} md={4}>
          <Link to={permalink}>
            {/* Hidden on mobile */}
            <Box component="header" display={{ xs: 'none', md: 'block' }}>
              <p className={styles.category}>{category}</p>
              <h2 className={styles.headlinePost}>{title}</h2>
            </Box>

            <p className={styles.excerpt}>{excerpt}</p>
          </Link>

          <Author
            authors={fields.authors}
            date={date}
            timeToRead={timeToRead}
          />
        </Grid>
      </Grid>
    </article>
  );
};
